import { render } from "./EmpleadoArchivosPanel.vue?vue&type=template&id=5c93f7fd&scoped=true"
import script from "./EmpleadoArchivosPanel.vue?vue&type=script&lang=js"
export * from "./EmpleadoArchivosPanel.vue?vue&type=script&lang=js"

import "./EmpleadoArchivosPanel.vue?vue&type=style&index=0&id=5c93f7fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c93f7fd"]])

export default __exports__